import React from 'react';
import { string, node } from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  margin-left: ${({ ml = '0px' }) => ml};
  margin-right: ${({ mr = '16px' }) => mr};
  margin-top: ${({ mt = 'none' }) => mt};
  display: flex;
  justify-content: flex-start;
`;

export const CheckBoxWrapper = ({ children, ml, mr, mt }) => (
  <StyledDiv ml={ml} mr={mr} mt={mt}>
    {children}
  </StyledDiv>
);

CheckBoxWrapper.defaultProps = {
  ml: '0px',
  mr: '16px',
  mt: 'none',
};
CheckBoxWrapper.propTypes = {
  children: node.isRequired,
  ml: string,
  mr: string,
  mt: string,
};
